module.exports = "<div class=\"col-12 scroll-v\">\n\t<ng2-smart-table [settings]=\"settings\" [source]=\"source\"></ng2-smart-table>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/administration/system-users-inactivation/history-inactivation-users/history-users-inactivation.component.html
// module id = ./src/app/administration/system-users-inactivation/history-inactivation-users/history-users-inactivation.component.html
// module chunks = main